

/// <reference path="StockNoteProductLine.ts" />

// Generated class WarehouseOrderLine_ManagedObject

class WarehouseOrderLine_ManagedObject extends StockNoteProductLine
{
}
